import { useRegistrationStatus } from "@/api/auth/useRegistrationStatus";

interface IUseExternalApiEnabledResult {
  isExternalApiEnabled: boolean;
  isLoading: boolean;
}

export const useExternalApiEnabled = (): IUseExternalApiEnabledResult => {
  const { data, isLoading } = useRegistrationStatus();
  return {
    isExternalApiEnabled: data?.externalApiEnabled ?? false,
    isLoading,
  };
};
